var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.9282 15.4641L3.56561 8.85666C3.2341 8.35458 3.29107 7.69049 3.70324 7.25219V7.25219C4.1159 6.81338 4.77622 6.71611 5.29789 7.01729L8.8905 9.09149L10.6788 5.99401C11.3072 4.90564 12.7718 4.65968 13.7213 5.48308L19.2329 10.2631C19.5949 10.5771 19.6833 11.1036 19.4438 11.5186L14.8564 19.4641L7.9282 15.4641Z",
    stroke: "#d7ccff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.79423 19.4282C6.31594 19.1521 6.15207 18.5405 6.42821 18.0622L7.92821 15.4641L14.8564 19.4641L13.3564 22.0622C13.0803 22.5405 12.4687 22.7044 11.9904 22.4282L6.79423 19.4282Z",
    stroke: "#d7ccff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWant);
export default __webpack_public_path__ + "static/media/want.fa6850ac38681747a14a6c227f5bb93c.svg";
export { ForwardRef as ReactComponent };